/* DON'T EDIT THIS FILE: edit original and run build again */ const rulebookValueOptions = {
  matesurInvertirGlobal: {
    label:
      "BALANZ INVERTIR GLOBAL (aprobado por resolución de la CNV N° 16.579 del 2/06/2011)",
  },
  matesurRentaFija: {
    label:
      "BALANZ RENTA FIJA FCI (aprobado por resolución de la CNV Nº 16.592 del 16/06/2011)",
  },
  matesurCapitalFci: {
    label:
      "BALANZ CAPITAL AHORRO FONDO COMÚN DE INVERSIÓN (aprobado por resolución de la CNV Nº 16.926 del 28/09/2012)",
  },
  matesurFciPymes: {
    label:
      "BALANZ CAPITAL PYMEs FCI ABIERTO PYMEs (aprobado por resolución de la CNV Nº 16.496 del 17/10/2012)",
  },
  matesurAcciones: {
    label:
      "BALANZ ACCIONES (aprobado por resolución de la CNV Nº 17.811 del 09/09/2015)",
  },
  matesurRentaEstrategicaFci: {
    label:
      "BALANZ RENTA FIJA ESTRATÉGICA FCI (aprobado por resolución de la CNV Nº 17.686 del 28/05/2015)",
  },
  matesurCapitalSubsoberano: {
    label:
      "BALANZ CAPITAL SUBSOBERANO (aprobado por resolución de la CNV N°17.686 del 28/05/2015)",
  },
  matesurRentaFijaDolares: {
    label:
      "BALANZ CAPITAL RENTA FIJA EN DÓLARES (aprobado por resolución de la CNV N°18.450 del 12/01/2017)",
  },
  matesurAhorroEnDolaresFci: {
    label:
      "BALANZ AHORRO EN DÓLARES FCI (aprobado por resolución de la CNV Nº 876 del 27/10/2016)",
  },
  matesurSudamericano: {
    label:
      "BALANZ SUDAMERICANO (aprobado por resolución de la CNV Nº 18.690 del 19/05/2017)",
  },
  matesurInstitucional: {
    label:
      "BALANZ INSTITUCIONAL (aprobado por la resolución de la CNV Nº 18.582 del 31/03/2017)",
  },
  matesurCapitalMultimercado: {
    label:
      "BALANZ CAPITAL MULTIMERCADO II (aprobado por la resolución de la CNV Nº 18.582 del 31/03/2017)",
  },
  matesurRentaFijaPublicaFci: {
    label:
      "BALANZ RENTA FIJA PÚBLICA FCI (aprobado por resolución de la CNV N° RESFC-2018-19566-APN-DIR#CNV del 14/06/2018)",
  },
  matesurMegaQMBalanceado: {
    label:
      "MEGAQM Balanceado (aprobado por resolución de la CNV N° 17.659 del 21/04/2015)",
  },
  matesurMegaQMLiquidez: {
    label:
      "MEGAQM Liquidez Dólar (aprobado por resolución de la CNV N° 18.380 del 24/11/2016)",
  },
  matesurMegaQMAhorro: {
    label:
      "MEGAQM Ahorro (aprobado por resolución de la CNV N° 15.214 del 20/10/2005)",
  },
  matesurMegaQMRentaGlobal: {
    label:
      "MEGAQM Renta Global dólares (aprobado por resolución de la CNV N° 19.915 del 05/12/2018)",
  },
  matesurMegaQMRetornoAbsoluto: {
    label:
      "MEGAQM Retorno Absoluto (aprobado por resolución de la CNV N° 18.469 del 19/01/2017)",
  },
  matesurMegaQMCobertura: {
    label:
      "MEGAQM Cobertura (aprobado por resolución de la CNV N° 16.887 del 16/08/2012)",
  },
  matesurMegaQMRentaMixta: {
    label:
      "MEGAQM Renta Mixta (aprobado por resolución de la CNV N° 17.421 del 14/08/2014)",
  },
  matesurMegaQMProvincial: {
    label:
      "MEGAQM Provincial (aprobado por resolución de la CNV N° 18.584 del 31/03/2017)",
  },
  matesurMegaQMSustentable: {
    label:
      "MEGAQM Sustentable ASG (aprobado por resolución de la CNV N° 21.165 del 03/06/2021)",
  },
  matesurMegaQMRetornoTotal: {
    label:
      "MEGAQM Retorno Total (aprobado por resolución de la CNV N° 17.296 del 20/02/2014)",
  },
  matesurMegaQMAcciones: {
    label:
      "MEGAQM Acciones (aprobado por resolución de la CNV N° 17.540 del 16/10/2014)",
  },
  matesurMegaQMCorporativoDolares: {
    label:
      "MEGAQM Corporativo Dólares (aprobado por resolución de la CNV N° 18.364 del 17/11/2016)",
  },
  matesurMegaQMLatamCorporativo: {
    label:
      "MEGAQM Latam Corporativo (aprobado por resolución de la CNV N° 19.985 del 16/01/2019)",
  },
  matesurMegaQMRentaFijaLatam: {
    label:
      "MEGAQM Renta Fija LATAM (aprobado por resolución de la CNV N° 18.448 del 12/01/2017)",
  },
  matesurMegaQMAhorroDolares: {
    label:
      "MEGAQM Ahorro Dólares (aprobado por resolución de la CNV N° 19.984 del 16/01/2019)",
  },
  matesurMegaQMEmpresasArgentinasFciAbiertoPymes: {
    label:
      "MEGAQM Empresas Argentinas FCI Abierto Pymes (aprobado por resolución de la CNV N° 16.782 del 27/03/2012)",
  },
  matesurMegaQMInfraestructuraEconomiaReal: {
    label:
      "MEGAQM FCI Abierto para el Financiamiento de la Infraestructura y la Economía Real (aprobado por resolución de la CNV N° 17.658 del 21/04/2015)",
  },
  matesurMegaQMPesos: {
    label:
      "MEGAQM Pesos (aprobado por resolución de la CNV N° 17.348 del 15/05/2014)",
  },
};

export default rulebookValueOptions;
